import { render, staticRenderFns } from "./RoomComponent.vue?vue&type=template&id=f9aef3bc&scoped=true"
import script from "./RoomComponent.vue?vue&type=script&lang=js"
export * from "./RoomComponent.vue?vue&type=script&lang=js"
import style0 from "./RoomComponent.vue?vue&type=style&index=0&id=f9aef3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9aef3bc",
  null
  
)

export default component.exports